import * as ScoreType from 'constants/ScoreType';
import * as GroupType from 'constants/GroupType';
import * as Period from 'constants/Period';

import * as MatchInfo from 'constants/MatchInfo';

const TENNIS_SCORE_MAP = {};
TENNIS_SCORE_MAP[Period.NOT_STARTED] = {
    [GroupType.DEFAULT_GROUP]: {
        info: MatchInfo.MATCH_NOT_STARTED,
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod],
        currentGame: ScoreType.CurrentGame
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.THIRD_PERIOD_GROUP]: {
        main: ScoreType.ThirdPeriod
    },
    [GroupType.FOURTH_PERIOD_GROUP]: {
        main: ScoreType.FourthPeriod
    },
    [GroupType.FIFTH_PERIOD_GROUP]: {
        main: ScoreType.FifthPeriod
    }
};

TENNIS_SCORE_MAP[Period.FIRST] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod],
        currentGame: ScoreType.CurrentGame
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.THIRD_PERIOD_GROUP]: {
        main: ScoreType.ThirdPeriod
    },
    [GroupType.FOURTH_PERIOD_GROUP]: {
        main: ScoreType.FourthPeriod
    },
    [GroupType.FIFTH_PERIOD_GROUP]: {
        main: ScoreType.FifthPeriod
    }
};

TENNIS_SCORE_MAP[Period.SECOND] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod],
        currentGame: ScoreType.CurrentGame
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.THIRD_PERIOD_GROUP]: {
        main: ScoreType.ThirdPeriod
    },
    [GroupType.FOURTH_PERIOD_GROUP]: {
        main: ScoreType.FourthPeriod
    },
    [GroupType.FIFTH_PERIOD_GROUP]: {
        main: ScoreType.FifthPeriod
    }
};

TENNIS_SCORE_MAP[Period.THIRD] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod],
        currentGame: ScoreType.CurrentGame
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.THIRD_PERIOD_GROUP]: {
        main: ScoreType.ThirdPeriod
    },
    [GroupType.FOURTH_PERIOD_GROUP]: {
        main: ScoreType.FourthPeriod
    },
    [GroupType.FIFTH_PERIOD_GROUP]: {
        main: ScoreType.FifthPeriod
    }
};

TENNIS_SCORE_MAP[Period.FOURTH] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [
            ScoreType.FirstPeriod,
            ScoreType.SecondPeriod,
            ScoreType.ThirdPeriod,
            ScoreType.FourthPeriod],
        currentGame: ScoreType.CurrentGame
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.THIRD_PERIOD_GROUP]: {
        main: ScoreType.ThirdPeriod
    },
    [GroupType.FOURTH_PERIOD_GROUP]: {
        main: ScoreType.FourthPeriod
    },
    [GroupType.FIFTH_PERIOD_GROUP]: {
        main: ScoreType.FifthPeriod
    }
};

TENNIS_SCORE_MAP[Period.FIFTH] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [
            ScoreType.FirstPeriod,
            ScoreType.SecondPeriod,
            ScoreType.ThirdPeriod,
            ScoreType.FourthPeriod,
            ScoreType.FifthPeriod],
        currentGame: ScoreType.CurrentGame
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.THIRD_PERIOD_GROUP]: {
        main: ScoreType.ThirdPeriod
    },
    [GroupType.FOURTH_PERIOD_GROUP]: {
        main: ScoreType.FourthPeriod
    },
    [GroupType.FIFTH_PERIOD_GROUP]: {
        main: ScoreType.FifthPeriod
    }
};

TENNIS_SCORE_MAP[Period.FINISHED] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [
            ScoreType.FirstPeriod,
            ScoreType.SecondPeriod,
            ScoreType.ThirdPeriod,
            ScoreType.FourthPeriod,
            ScoreType.FifthPeriod]
    }
};

export default TENNIS_SCORE_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Tennis/ScoreMap.js